import { render, staticRenderFns } from "./ClientProductList.vue?vue&type=template&id=9797902e&scoped=true&"
import script from "./ClientProductList.vue?vue&type=script&lang=js&"
export * from "./ClientProductList.vue?vue&type=script&lang=js&"
import style0 from "./ClientProductList.vue?vue&type=style&index=0&id=9797902e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9797902e",
  null
  
)

export default component.exports